import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const CopyIcon = ({
  title = 'Copy',
  viewBox = '0 0 20 18',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    {/* prettier-ignore */}
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2473_73898)">
        <path d="M15 7.54883H8.25C7.42157 7.54883 6.75 8.2204 6.75 9.04883V15.7988C6.75 16.6273 7.42157 17.2988 8.25 17.2988H15C15.8284 17.2988 16.5 16.6273 16.5 15.7988V9.04883C16.5 8.2204 15.8284 7.54883 15 7.54883Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.75 12.0488H3C2.60218 12.0488 2.22064 11.8908 1.93934 11.6095C1.65804 11.3282 1.5 10.9467 1.5 10.5488V3.79883C1.5 3.401 1.65804 3.01947 1.93934 2.73817C2.22064 2.45686 2.60218 2.29883 3 2.29883H9.75C10.1478 2.29883 10.5294 2.45686 10.8107 2.73817C11.092 3.01947 11.25 3.401 11.25 3.79883V4.54883" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_2473_73898">
          <rect width="18" height="18" fill="white" transform="translate(0 0.798828)" />
        </clipPath>
      </defs>
    </svg>
  </CreateIconComponent>
);

export default CopyIcon;
